import { styled, keyframes } from "@pigment-css/react";

const shimmer = keyframes({
  "0%": { backgroundPosition: "-200px 0" },
  "100%": { backgroundPosition: "200px 0" },
});

const HeadersContainer = styled("div")({
  display: "flex",
  gap: "0",
});

const HeaderColumn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[26],
  flex: 1,
}));

const SkeletonElement = styled("div")(({ theme }) => ({
  borderRadius: theme.managementView.radius[10],
  background: `linear-gradient(90deg, ${theme.colors.neutral[200]} 0%, ${theme.colors.neutral[100]} 50%, ${theme.colors.neutral[200]} 100%)`,
  backgroundSize: "400px 100%",
  animation: `${shimmer} 1.5s ease-in-out infinite`,
}));

const TitleSkeleton = styled(SkeletonElement)({
  height: "14px",
  width: "60px",
});

const ValueSkeleton = styled(SkeletonElement)({
  height: "21px",
  width: "80px",
});

interface KPIHeadersSkeletonProps {
  columnCount?: number;
}

export const KPIHeadersSkeleton = ({ columnCount = 5 }: KPIHeadersSkeletonProps) => {
  return (
    <HeadersContainer>
      {Array.from({ length: columnCount }).map((_, index) => (
        <HeaderColumn key={index}>
          <TitleSkeleton />
          <ValueSkeleton />
        </HeaderColumn>
      ))}
    </HeadersContainer>
  );
};
